export const groupColorLookup = [
    {
        label: "Preset 1", // black
        value: "is-dark",
        hex : "#00ffe7"
    },
    {
        label: "Preset 2", // black
        value: "is-mining",
        hex : "#00ffe7"
    },
    {
        label: "Preset 3", // black
        value: "is-oilgas",
        hex : "#00ffe7"
    },
    {
        label: "Deep Saffron", // text black
        value: "is-deep-saffron",
        hex : "#fa9f42"
    },
    {
        label: "Rust", // white
        value: "is-rust",
        hex : "#af3800"
    },
    {
        label: "Indigo Dye", // white
        value: "is-indigo-dye",
        hex : "#2b4162"
    },
    {
        label: "Russian Violet", // white
        value: "is-russian-violet",
        hex : "#231651"
    },
    {
        label: "Claret", // white
        value: "is-claret",
        hex : "#89043d"
    },
    {
        label: "Golden Gate Orange", // white
        value: "is-gg-orange",
        hex : "#bb342f"
    },
    {
        label: "Army Green", // white
        value: "is-army-green",
        hex : "#41521f"
    },
    {
        label: "Spanish Blue", // white
        value: "is-spanish-blue",
        hex : "#2374ab"
    },
    {
        label: "French Lilac", // white
        value: "is-french-lilac",
        hex : "#8d6a9f"
    },
    {
        label: "Cadet Blue", // white
        value: "is-cadet-blue",
        hex : "#51a3a3"
    },
    {
        label: "Turqoise Blue", // black
        value: "is-turqoise-blue",
        hex : "#00ffe7"
    }
];




// WEBPACK FOOTER //
// ./src/constants/RepGroupColors.js